import {
  Button,
  Container,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import {useFormik} from 'formik';
import React, {FC, useState} from 'react';
import {TranslationKeys} from 'translations';
import {userValidationSchema} from 'utils/dataValidations';

import {TitledSection} from '../../layouts/aside-layout';

interface IProps {
  another_person: {
    name: string;
    phone: string;
  };
  onChange: ({name, phone}: {name: string; phone: string}) => void;
  t: (term: TranslationKeys) => string;
}

export const RecipientData: FC<IProps> = ({another_person, onChange, t}) => {
  const [isChangedForm, setIsChangedForm] = useState(false);

  const formik = useFormik({
    validationSchema: userValidationSchema(t),
    initialValues: another_person,
    onSubmit: () => {
      onChange(formik.values);
      setIsChangedForm(false);
    },
  });

  const onChangeVisibleBtn = () => {
    setIsChangedForm(true);
  };

  return (
    <TitledSection title={t('RECIPIENT_DATA')}>
      <Container display="flex" alignItems="center" variant="white-block">
        <SimpleGrid columns={[1, 2]} spacing="30px">
          <FormControl isRequired isInvalid={!!formik.errors.name} onChange={() => onChangeVisibleBtn()}>
            <FormLabel
              fontWeight={600}
              requiredIndicator={
                <Text as="span" ml="4px" color="red">
                  *
                </Text>
              }
            >
              {t('USER_NAME')}
            </FormLabel>
            <Input
              id="name"
              name="name"
              type="text"
              placeholder={t('USER_NAME')}
              mt="6px"
              onChange={formik.handleChange}
              value={formik.values.name}
            />
            <FormErrorMessage>{formik.errors.name}</FormErrorMessage>
          </FormControl>
          <Flex flexDirection="column">
            <FormControl isRequired isInvalid={!!formik.errors.phone} onChange={() => onChangeVisibleBtn()}>
              <FormLabel
                fontWeight={600}
                requiredIndicator={
                  <Text as="span" ml="4px" color="red">
                    *
                  </Text>
                }
              >
                {t('USER_PHONE_NUMBER')}
              </FormLabel>
              <Input
                id="phone"
                name="phone"
                type="phone"
                placeholder={t('USER_PHONE_NUMBER')}
                mt="6px"
                onChange={formik.handleChange}
                value={formik.values.phone}
              />
              <FormErrorMessage>{formik.errors.phone}</FormErrorMessage>
            </FormControl>
            {isChangedForm && (
              <Button
                variant="primary"
                w="50%"
                alignSelf="flex-end"
                h="40px"
                mt="20px"
                onClick={() => formik.submitForm()}
                // isLoadingUpdate={isLoadingUpdate}
              >
                {t('SAVE')}
              </Button>
            )}
          </Flex>
        </SimpleGrid>
      </Container>
    </TitledSection>
  );
};
